import React from 'react';

const About = () => {
    return (
        <div>
         
         <h1>Developer Sleeping.........../////........</h1>
        </div>
    );
};

export default About;